/**
 * /tenants/$slug/access-governance/credential-recovery/$requestId — one credential recovery request.
 */

import { createFileRoute } from "@tanstack/react-router";
import { credentialRecoveryKeys, fetchRecoveryRequest } from "@/features/credential-recovery/queries";
import { RecoveryRequestPage } from "@/features/credential-recovery/pages/recovery-request-page";

export const Route = createFileRoute("/_authed/tenants/$slug/access-governance/credential-recovery/$requestId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: credentialRecoveryKeys.request(context.tenant.id, params.requestId),
      queryFn: () => fetchRecoveryRequest(context.tenant.id, params.requestId),
    }),
  component: RecoveryRequestPage,
});
